module.exports = __webpack_public_path__ + "img/services-3.17434fa8.jpg";